const FormError=({errors,name})=>{
    const error = errors[name]

    if(error){
        return <p className="text-red-400 text-sm mb-2">{error.message || "Requerido"}</p>
    }
    return ""
}

export default FormError